const DEFAULT_PROFILES = 
    {
        'Instagram': [
            /* ---------- Instagram ---------- */
            {
            "name": "Instagram Square Post (1:1)",
            "exportWidth": 1080,
            "exportHeight": 1080,
            "resizeMode": "static_size",
            "aspectRatio": { "width": 1, "height": 1 }
            },
            {
            "name": "Instagram Portrait Post (4:5)",
            "exportWidth": 1080,
            "exportHeight": 1350,
            "resizeMode": "static_size",
            "aspectRatio": { "width": 4, "height": 5 }
            },
            {
            "name": "Instagram Landscape Post (1.91:1)",
            "exportWidth": 1080,
            "exportHeight": 566,
            "resizeMode": "static_size",
            "aspectRatio": { "width": 191, "height": 100 }
            },
            {
            "name": "Instagram Story (9:16)",
            "exportWidth": 1080,
            "exportHeight": 1920,
            "resizeMode": "static_size",
            "aspectRatio": { "width": 9, "height": 16 }
            },
            {
            "name": "Instagram Profile Picture (1:1)",
            "exportWidth": 320,
            "exportHeight": 320,
            "resizeMode": "static_size",
            "aspectRatio": { "width": 1, "height": 1 }
            },
        ],
        'Facebook': [
        /* ---------- Facebook ---------- */
        {
          "name": "Facebook Feed Landscape (1.91:1)",
          "exportWidth": 1200,
          "exportHeight": 630,
          "resizeMode": "static_size",
          "aspectRatio": { "width": 191, "height": 100 }
        },
        {
          "name": "Facebook Feed Square (1:1)",
          "exportWidth": 1080,
          "exportHeight": 1080,
          "resizeMode": "static_size",
          "aspectRatio": { "width": 1, "height": 1 }
        },
        {
          "name": "Facebook Feed Portrait (4:5)",
          "exportWidth": 1080,
          "exportHeight": 1350,
          "resizeMode": "static_size",
          "aspectRatio": { "width": 4, "height": 5 }
        },
        {
          "name": "Facebook Story (9:16)",
          "exportWidth": 1080,
          "exportHeight": 1920,
          "resizeMode": "static_size",
          "aspectRatio": { "width": 9, "height": 16 }
        },
        {
          "name": "Facebook Cover Photo (820x312)",
          "exportWidth": 820,
          "exportHeight": 312,
          "resizeMode": "static_size",
          "aspectRatio": { "width": 205, "height": 78 }
        },
      ],
      'X': [
        /* ---------- X / Twitter ---------- */
        {
          "name": "X Feed Landscape (16:9)",
          "exportWidth": 1600,
          "exportHeight": 900,
          "resizeMode": "static_size",
          "aspectRatio": { "width": 16, "height": 9 }
        },
        {
          "name": "X Feed Square (1:1)",
          "exportWidth": 1080,
          "exportHeight": 1080,
          "resizeMode": "static_size",
          "aspectRatio": { "width": 1, "height": 1 }
        },
        {
          "name": "X Feed Portrait (4:5)",
          "exportWidth": 1080,
          "exportHeight": 1350,
          "resizeMode": "static_size",
          "aspectRatio": { "width": 4, "height": 5 }
        },
        {
          "name": "X Header Image (3:1)",
          "exportWidth": 1500,
          "exportHeight": 500,
          "resizeMode": "static_size",
          "aspectRatio": { "width": 3, "height": 1 }
        },
        {
          "name": "X Profile Picture (1:1)",
          "exportWidth": 400,
          "exportHeight": 400,
          "resizeMode": "static_size",
          "aspectRatio": { "width": 1, "height": 1 }
        },
      ],
      'LinkedIn': [
        /* ---------- LinkedIn ---------- */
        {
          "name": "LinkedIn Feed Landscape (1.91:1)",
          "exportWidth": 1200,
          "exportHeight": 627,
          "resizeMode": "static_size",
          "aspectRatio": { "width": 191, "height": 100 }
        },
        {
          "name": "LinkedIn Feed Square (1:1)",
          "exportWidth": 1080,
          "exportHeight": 1080,
          "resizeMode": "static_size",
          "aspectRatio": { "width": 1, "height": 1 }
        },
        {
          "name": "LinkedIn Feed Portrait (4:5)",
          "exportWidth": 1080,
          "exportHeight": 1350,
          "resizeMode": "static_size",
          "aspectRatio": { "width": 4, "height": 5 }
        },
        {
          "name": "LinkedIn Profile Picture (1:1)",
          "exportWidth": 400,
          "exportHeight": 400,
          "resizeMode": "static_size",
          "aspectRatio": { "width": 1, "height": 1 }
        },
        {
          "name": "LinkedIn Cover Photo (4:1)",
          "exportWidth": 1584,
          "exportHeight": 396,
          "resizeMode": "static_size",
          "aspectRatio": { "width": 4, "height": 1 }
        },
      ],
      'TikTok': [
        /* ---------- TikTok ---------- */
        {
          "name": "TikTok Vertical Video Cover (9:16)",
          "exportWidth": 1080,
          "exportHeight": 1920,
          "resizeMode": "static_size",
          "aspectRatio": { "width": 9, "height": 16 }
        },
        {
          "name": "TikTok Profile Picture (1:1)",
          "exportWidth": 200,
          "exportHeight": 200,
          "resizeMode": "static_size",
          "aspectRatio": { "width": 1, "height": 1 }
        },
        {
          "name": "TikTok Feed Preview (1:1)",
          "exportWidth": 1080,
          "exportHeight": 1080,
          "resizeMode": "static_size",
          "aspectRatio": { "width": 1, "height": 1 }
        },
        {
          "name": "TikTok Ad Vertical (9:16)",
          "exportWidth": 1080,
          "exportHeight": 1920,
          "resizeMode": "static_size",
          "aspectRatio": { "width": 9, "height": 16 }
        },
        {
          "name": "TikTok Carousel Image (4:5)",
          "exportWidth": 1080,
          "exportHeight": 1350,
          "resizeMode": "static_size",
          "aspectRatio": { "width": 4, "height": 5 }
        },
      ],
      'Pinterest': [
        /* ---------- Pinterest ---------- */
        {
          "name": "Pinterest Standard Pin (2:3)",
          "exportWidth": 1000,
          "exportHeight": 1500,
          "resizeMode": "static_size",
          "aspectRatio": { "width": 2, "height": 3 }
        },
        {
          "name": "Pinterest Long Pin (1:2.1)",
          "exportWidth": 1000,
          "exportHeight": 2100,
          "resizeMode": "static_size",
          "aspectRatio": { "width": 10, "height": 21 }
        },
        {
          "name": "Pinterest Square Pin (1:1)",
          "exportWidth": 1000,
          "exportHeight": 1000,
          "resizeMode": "static_size",
          "aspectRatio": { "width": 1, "height": 1 }
        },
        {
          "name": "Pinterest Profile Picture (1:1)",
          "exportWidth": 165,
          "exportHeight": 165,
          "resizeMode": "static_size",
          "aspectRatio": { "width": 1, "height": 1 }
        },
        {
          "name": "Pinterest Board Cover (1:1)",
          "exportWidth": 222,
          "exportHeight": 222,
          "resizeMode": "static_size",
          "aspectRatio": { "width": 1, "height": 1 }
        },
      ],
      'YouTube': [
        /* ---------- YouTube ---------- */
        {
          "name": "YouTube Thumbnail (16:9)",
          "exportWidth": 1280,
          "exportHeight": 720,
          "resizeMode": "static_size",
          "aspectRatio": { "width": 16, "height": 9 }
        },
        {
          "name": "YouTube Channel Banner (16:9)",
          "exportWidth": 2560,
          "exportHeight": 1440,
          "resizeMode": "static_size",
          "aspectRatio": { "width": 16, "height": 9 }
        },
        {
          "name": "YouTube Profile Picture (1:1)",
          "exportWidth": 800,
          "exportHeight": 800,
          "resizeMode": "static_size",
          "aspectRatio": { "width": 1, "height": 1 }
        },
        {
          "name": "YouTube Community Post Square (1:1)",
          "exportWidth": 1080,
          "exportHeight": 1080,
          "resizeMode": "static_size",
          "aspectRatio": { "width": 1, "height": 1 }
        },
        {
          "name": "YouTube Community Post Landscape (16:9)",
          "exportWidth": 1200,
          "exportHeight": 675,
          "resizeMode": "static_size",
          "aspectRatio": { "width": 16, "height": 9 }
        }
      ]
    };
      
export default DEFAULT_PROFILES;
